import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import { store } from './store/index'
import './registerServiceWorker'
import VueResource from 'vue-resource';
import VueNativeSock from 'vue-native-websocket'
import VueI18n from 'vue-i18n'
import VueApexCharts from 'vue-apexcharts'
import { zh } from './locale/zh';
import { en } from './locale/en';

import './styles/common.scss';
import './styles/components/tables.scss'
import './plugins/date-range-picker'

const API_URL = process.env.VUE_APP_API_URL

// import VueSocketio from 'vue-socket.io';
// import socketio from 'socket.io-client';
// import io from 'socket.io';


Vue.use(VueResource);
Vue.use(VueI18n)
Vue.use(VueApexCharts)

var i18n = new VueI18n({
  locale: 'zh',
  messages: {
    en: en,
    zh: zh
  }
})

// Vue.use(VueSocketio,'localhost:8080');
// Vue.use(VueSocketio, socketio('http://localhost:8080'), store);

var url = `${API_URL}/test/sos`;
//var url = 'http://13.58.187.187:4000/test/sos'
var sos = null;
Vue.http.get(url).then(r => {

  sos = r.data;
  console.log(sos);
  switch (sos.os) {
    case 'w':
      //url = `ws://3.17.153.99:8081/client/ws/speech?content-type=audio/x-raw,+layout=(string)interleaved,+rate=(int)16000,+format=(string)S16LE,+channels=(int)1
	  //url = `ws://10.8.8.181:8081/WEBService/ServiceServer`; //Gray
    // url = `ws://10.8.8.185:8081/WEBService/ServiceServer2`; //Alim
    url = `wss://zn-clinic.kenkone-evas.com/wss/WEBService/ServiceServer2`; //Alim
	  break;
    case 'u':
      //if (sos.host == 'top.kenkone.com') {
        //url = `wss://${sos.host}:8081/client/ws/speech?content-type=audio/x-raw,+layout=(string)interleaved,+rate=(int)16000,+format=(string)S16LE,+channels=(int)1`;
		//url = `ws://${sos.host}:8081/WEBService/ServiceServer`; //Gray
		url = `wss://zn-clinic.kenkone-evas.com/wss/WEBService/ServiceServer2`; //Alim
	  //} else {
        //url = `ws://${sos.host}:8081/client/ws/speech?content-type=audio/x-raw,+layout=(string)interleaved,+rate=(int)16000,+format=(string)S16LE,+channels=(int)1`;
      //}
      break;
  }

  Vue.use(VueNativeSock, url, { // /client/ws/status
    format: 'S16LE',
    connectManually: true
  });

  Vue.config.productionTip = false

  Vue.http.options.xhr = {
    withCredentials: true
  };
  Vue.http.options.emulateJSON = true;

  Vue.component('apexchart', VueApexCharts)

  /***** TODO *****/
  /***** Need to maintain sign in state *****/

  new Vue({
    i18n: i18n,
    router,
    store,
    render: h => h(App),
    created() {}
  }).$mount('#app')

});
